import React, { useState } from 'react';
import Header from '../components/header';
import Footers from '../components/footers';
import UserCourses from '../components/usercourses';
import { useNavigate } from 'react-router-dom';
import { serverURL, MonthType, MonthCost, YearType, YearCost } from '../constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { usePWAInstall } from 'react-use-pwa-install';
import { Button, Modal } from 'flowbite-react';
import { AiOutlineLoading } from 'react-icons/ai';
import { HiOutlineExclamationCircle } from "react-icons/hi";

const Home = () => {
    const navigate = useNavigate();
    const install = usePWAInstall();
    const [activeTab, setActiveTab] = useState('courses');
    const [mName, setName] = useState(sessionStorage.getItem('mName'));
    const [email, setEmail] = useState(sessionStorage.getItem('email'));
    const [password, setPassword] = useState('');
    const [processing, setProcessing] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [processingDelete, setProcessingDelete] = useState(false);
    const [invoices, setInvoices] = useState([]);
    const userType = sessionStorage.getItem('type') || 'free';

    const getPlan = () => {
        if (userType === 'forever') return { name: 'Lifetime', price: 'Free', badge: 'bg-black text-white dark:bg-white dark:text-black' };
        if (userType === MonthType) return { name: 'Monthly', price: `$${MonthCost}/mo`, badge: 'bg-black text-white dark:bg-white dark:text-black' };
        if (userType === YearType) return { name: 'Yearly', price: `$${YearCost}/yr`, badge: 'bg-black text-white dark:bg-white dark:text-black' };
        return { name: 'Free', price: '$0', badge: 'border border-black dark:border-white text-black dark:text-white' };
    };
    const plan = getPlan();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email || !mName) { toast.error('Please fill in all fields'); return; }
        setProcessing(true);
        try {
            const response = await axios.post(serverURL + '/api/profile', { email, mName, password, uid: sessionStorage.getItem('uid') });
            if (response.data.success) {
                toast.success('Profile updated');
                sessionStorage.setItem('email', email);
                sessionStorage.setItem('mName', mName);
            }
        } catch { toast.error('Error updating profile'); }
        setProcessing(false);
    };

    const startDeletion = async () => {
        setProcessingDelete(true);
        try {
            const response = await axios.post(serverURL + '/api/deleteuser', { userId: sessionStorage.getItem('uid') });
            if (response.data.success) { toast.success('Account deleted'); sessionStorage.clear(); navigate('/signin'); }
        } catch { toast.error('Error'); }
        setProcessingDelete(false); setOpenModal(false);
    };

    const fetchInvoices = async () => {
        try {
            const response = await axios.get(serverURL + '/api/myinvoices?userId=' + sessionStorage.getItem('uid'));
            setInvoices(response.data);
        } catch (error) { console.error(error); }
    };

    const Tab = ({ id, label, icon }) => (
        <button onClick={() => setActiveTab(id)}
            className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === id ? 'border-black dark:border-white text-black dark:text-white' : 'border-transparent text-gray-400 hover:text-gray-600'}`}>
            <span>{icon}</span> {label}
        </button>
    );

    return (
        <div className='min-h-screen flex flex-col bg-white dark:bg-black'>
            <Header isHome={true} className="sticky top-0 z-50" />
            <div className='flex-1'>
                {/* User Header */}
                <div className='border-b border-gray-200 dark:border-gray-800'>
                    <div className='max-w-6xl mx-auto px-4 py-6 flex items-center justify-between'>
                        <div className='flex items-center gap-4'>
                            <div className='w-12 h-12 bg-black dark:bg-white text-white dark:text-black rounded-full flex items-center justify-center text-xl font-black'>
                                {(mName || 'U').charAt(0).toUpperCase()}
                            </div>
                            <div>
                                <h1 className='text-lg font-black dark:text-white'>{mName}</h1>
                                <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${plan.badge}`}>{plan.name} Plan</span>
                            </div>
                        </div>
                        <button onClick={() => navigate('/create')}
                            className='bg-black dark:bg-white text-white dark:text-black font-bold px-5 py-2.5 rounded-lg text-sm hover:opacity-90'>
                            + Generate Course
                        </button>
                    </div>
                </div>

                {/* Tabs */}
                <div className='border-b border-gray-200 dark:border-gray-800'>
                    <div className='max-w-6xl mx-auto px-4 flex overflow-x-auto no-scrollbar'>
                        <Tab id="courses" label="My Courses" icon="📚" />
                        <Tab id="subscription" label="Subscription" icon="💳" />
                        <Tab id="profile" label="Profile" icon="👤" />
                        <Tab id="settings" label="Settings" icon="⚙️" />
                    </div>
                </div>

                {/* Tab Content */}
                <div className='max-w-6xl mx-auto px-4 py-6'>

                    {/* Courses Tab */}
                    {activeTab === 'courses' && (
                        <UserCourses userId={sessionStorage.getItem('uid')} />
                    )}

                    {/* Subscription Tab */}
                    {activeTab === 'subscription' && (
                        <div className='max-w-2xl space-y-5'>
                            <div className='border border-gray-200 dark:border-gray-800 rounded-lg p-5'>
                                <div className='flex items-center justify-between mb-4'>
                                    <div>
                                        <p className='text-xs text-gray-400 uppercase font-bold'>Current Plan</p>
                                        <p className='text-xl font-black dark:text-white'>{plan.name} Plan</p>
                                    </div>
                                    <p className='text-2xl font-black dark:text-white'>{plan.price}</p>
                                </div>
                                {userType === 'free' ? (
                                    <div>
                                        <p className='text-sm text-gray-500 mb-4'>Upgrade to unlock all features.</p>
                                        <button onClick={() => navigate('/pricing', { state: { header: true } })}
                                            className='w-full bg-black dark:bg-white text-white dark:text-black font-bold py-3 rounded-lg hover:opacity-90'>
                                            Upgrade Plan
                                        </button>
                                    </div>
                                ) : userType !== 'forever' ? (
                                    <div className='flex gap-3'>
                                        <button onClick={() => navigate('/pricing', { state: { header: true } })}
                                            className='flex-1 border border-black dark:border-white text-black dark:text-white font-bold py-2.5 rounded-lg text-sm hover:bg-gray-50 dark:hover:bg-gray-900'>
                                            Change Plan
                                        </button>
                                        <button onClick={() => navigate('/subscription')}
                                            className='flex-1 border border-gray-300 text-gray-500 font-bold py-2.5 rounded-lg text-sm hover:bg-gray-50'>
                                            Manage / Cancel
                                        </button>
                                    </div>
                                ) : (
                                    <p className='text-sm text-gray-500'>You have lifetime access to all features.</p>
                                )}
                            </div>

                            <div className='border border-gray-200 dark:border-gray-800 rounded-lg p-5'>
                                <p className='text-xs text-gray-400 uppercase font-bold mb-3'>Your Features</p>
                                <div className='space-y-2'>
                                    {[
                                        { name: `Generate ${userType === 'free' ? '5' : '10'} Sub-Topics`, on: true },
                                        { name: 'Create Unlimited Courses', on: true },
                                        { name: 'Video & Theory Course', on: userType !== 'free' },
                                        { name: 'Theory & Image Course', on: true },
                                        { name: 'Course In 23+ Languages', on: userType !== 'free' },
                                        { name: 'AI Teacher Chat', on: userType !== 'free' },
                                        { name: 'Download Certificates', on: userType !== 'free' },
                                    ].map((f, i) => (
                                        <div key={i} className={`flex items-center gap-2 text-sm ${f.on ? 'text-black dark:text-white' : 'text-gray-300 dark:text-gray-700 line-through'}`}>
                                            <span className={f.on ? 'text-green-600' : 'text-gray-300'}>{ f.on ? '✓' : '✗'}</span>
                                            {f.name}
                                        </div>
                                    ))}
                                </div>
                                {userType === 'free' && (
                                    <button onClick={() => navigate('/pricing', { state: { header: true } })}
                                        className='mt-4 text-sm font-bold text-black dark:text-white underline'>
                                        Upgrade to unlock all →
                                    </button>
                                )}
                            </div>

                            <div className='border border-gray-200 dark:border-gray-800 rounded-lg p-5'>
                                <div className='flex items-center justify-between mb-3'>
                                    <p className='text-xs text-gray-400 uppercase font-bold'>Billing & Invoices</p>
                                    <button onClick={fetchInvoices} className='text-xs text-blue-600 font-medium'>Load invoices</button>
                                </div>
                                {userType !== 'free' && (
                                    <div className='flex items-center justify-between py-2 border-b border-gray-100 dark:border-gray-800 mb-2'>
                                        <div>
                                            <p className='text-sm font-medium dark:text-white'>{plan.name} Plan</p>
                                            <p className='text-xs text-gray-400'>Active subscription</p>
                                        </div>
                                        <div className='text-right'>
                                            <p className='text-sm font-bold dark:text-white'>{plan.price}</p>
                                            <span className='text-xs bg-green-50 text-green-700 px-2 py-0.5 rounded-full'>Active</span>
                                        </div>
                                    </div>
                                )}
                                {invoices.length > 0 ? invoices.map(inv => (
                                    <div key={inv._id} className='flex items-center justify-between py-2 border-b border-gray-50 dark:border-gray-800'>
                                        <div>
                                            <p className='text-sm dark:text-white'>{inv.plan}</p>
                                            <p className='text-xs text-gray-400'>{new Date(inv.date).toLocaleDateString()} · {inv.method}</p>
                                        </div>
                                        <div className='text-right'>
                                            <p className='text-sm font-bold dark:text-white'>${inv.amount}</p>
                                            <span className={`text-xs px-2 py-0.5 rounded-full ${inv.status === 'paid' ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-500'}`}>{inv.status}</span>
                                        </div>
                                    </div>
                                )) : (
                                    <p className='text-xs text-gray-400 py-2'>{userType === 'free' ? 'No billing history — free plan.' : 'Click "Load invoices" to see history.'}</p>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Profile Tab */}
                    {activeTab === 'profile' && (
                        <div className='max-w-lg'>
                            <form onSubmit={handleSubmit} className='space-y-5'>
                                <div>
                                    <label className='text-sm font-bold text-black dark:text-white block mb-1.5'>Name</label>
                                    <input value={mName} onChange={(e) => setName(e.target.value)}
                                        className='border border-gray-300 dark:border-gray-700 dark:bg-black dark:text-white rounded-lg w-full px-3 py-2.5 text-sm focus:ring-black focus:border-black' type="text" />
                                </div>
                                <div>
                                    <label className='text-sm font-bold text-black dark:text-white block mb-1.5'>Email</label>
                                    <input value={email} onChange={(e) => setEmail(e.target.value)}
                                        className='border border-gray-300 dark:border-gray-700 dark:bg-black dark:text-white rounded-lg w-full px-3 py-2.5 text-sm focus:ring-black focus:border-black' type="email" />
                                </div>
                                <div>
                                    <label className='text-sm font-bold text-black dark:text-white block mb-1.5'>New Password</label>
                                    <input value={password} onChange={(e) => setPassword(e.target.value)}
                                        className='border border-gray-300 dark:border-gray-700 dark:bg-black dark:text-white rounded-lg w-full px-3 py-2.5 text-sm focus:ring-black focus:border-black' type="password" placeholder='Leave empty to keep current' />
                                </div>
                                <button type="submit" disabled={processing}
                                    className='w-full bg-black dark:bg-white text-white dark:text-black font-bold py-3 rounded-lg hover:opacity-90 disabled:opacity-50'>
                                    {processing ? 'Saving...' : 'Save Changes'}
                                </button>
                            </form>
                        </div>
                    )}

                    {/* Settings Tab */}
                    {activeTab === 'settings' && (
                        <div className='max-w-lg space-y-5'>
                            {install && (
                                <div className='border border-gray-200 dark:border-gray-800 rounded-lg p-5'>
                                    <p className='text-sm font-bold dark:text-white mb-1'>Desktop App</p>
                                    <p className='text-xs text-gray-400 mb-3'>Install Coursea as a desktop app.</p>
                                    <button onClick={install}
                                        className='border border-black dark:border-white text-black dark:text-white font-bold py-2 px-4 rounded-lg text-sm'>
                                        Install App
                                    </button>
                                </div>
                            )}
                            <div className='border border-red-100 dark:border-red-900 rounded-lg p-5'>
                                <p className='text-sm font-bold text-red-600 mb-1'>Danger Zone</p>
                                <p className='text-xs text-gray-400 mb-3'>Permanently delete your account and all courses.</p>
                                <button onClick={() => {
                                    if (sessionStorage.getItem('adminEmail') === sessionStorage.getItem('email')) {
                                        toast.error("Admin account cannot be deleted");
                                    } else { setOpenModal(true); }
                                }} className='bg-red-600 text-white font-bold py-2 px-4 rounded-lg text-sm hover:bg-red-700'>
                                    Delete Account
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Modal show={openModal} size="md" onClose={() => setOpenModal(false)} popup>
                <Modal.Body className='bg-white dark:bg-black pt-4'>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-red-600" />
                        <h3 className="mb-2 text-lg font-bold text-black dark:text-white">Delete your account?</h3>
                        <p className='text-sm text-gray-500 mb-5'>All courses and data will be permanently deleted.</p>
                        <div className="flex justify-center gap-3">
                            <Button isProcessing={processingDelete} processingSpinner={<AiOutlineLoading className="h-6 w-6 animate-spin" />}
                                className='rounded-lg' color="failure" onClick={startDeletion}>Yes, delete</Button>
                            <Button className='rounded-lg dark:text-white' color="gray" onClick={() => setOpenModal(false)}>Cancel</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Footers className="sticky bottom-0 z-50" />
        </div>
    );
};

export default Home;
